import { render } from "./CustomCheckboxTagsAdd.vue?vue&type=template&id=e56abedc"
import script from "./CustomCheckboxTagsAdd.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxTagsAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__